import { Card } from '@/components/ui/card'
import AuthLayout from '@/views/auth-layout'
import { Button } from '@/components/ui/button'
import { verifyEmailResend } from '@/api/auth'
import { toast } from '@/hooks/use-toast'
import { useTranslation } from 'react-i18next'

export default function VerifyEmailPage() {
  const { t } = useTranslation()
  async function resend() {
    try {
      await verifyEmailResend()
      toast({ title: 'Verification email sent', description: 'Please check your inbox.' })
    } catch (e: any) {
      toast({ variant: 'destructive', title: e?.response?.data?.error ?? 'Failed to send email' })
    }
  }

  return (
    <AuthLayout>
      <Card className='p-6'>
        <div className='flex flex-col space-y-2 text-center'>
          <h1 className='text-2xl font-semibold tracking-tight'>{t('verify_email_title')}</h1>
          <p className='text-sm text-muted-foreground'>{t('verify_email_desc')}</p>
        </div>
        <div className='pt-4 flex justify-center'>
          <Button onClick={resend}>Resend verification email</Button>
        </div>
      </Card>
    </AuthLayout>
  )
}